<style lang="scss">
  @use "../../../../assets/css/design-system/utils";

  .date-picker-body {
    display: flex;
    flex-direction: column;
  }

  .time-selector-container {
    display: flex;
    justify-content: center;
    padding: utils.in_rem(12px) utils.in_rem(20px);
  }
</style>

<script>
  import TimeInputModalFooter from "../Modals/TimeInputModalFooter.svelte";
  import TimeInputModalHeader from "../Modals/TimeInputModalHeader.svelte";
  import TimeSelector from "../TimeSelector/TimeSelector.svelte";
  import { getDatePickerContext } from "./context.svelte.js";
  import DatePickerCalendar from "./DatePickerComponents/DatePickerCalendar.svelte";

  const datePickerContext = getDatePickerContext();

  const handleApply = () => {
    datePickerContext.applyPendingDate();
  };

  const handleCancel = () => {
    datePickerContext.showModal = false;

    // In modal-only mode, call onApply with null to signal cancellation
    if (datePickerContext.onApply) {
      datePickerContext.onApply(null);
    }
  };

  const handleDayClick = (clickedDay) => {
    datePickerContext.setPendingDate(clickedDay.fullDate);
  };
</script>

<div class="date-picker-body">
  <TimeInputModalHeader />
  <DatePickerCalendar {handleDayClick} />
  {#if datePickerContext.includeTime}
    <div class="time-selector-container">
      <TimeSelector
        placeholder="Select time"
        bind:selectedTime={datePickerContext.selectedTime}
      />
    </div>
  {/if}
  <TimeInputModalFooter
    onApply={handleApply}
    onCancel={handleCancel}
    applyButtonText={datePickerContext.customButtonText || "Apply"}
  />
</div>
